import type {TargetEntities, TargetEntity} from 'src/types/target-entity-types';
import {
  RECEIVE_TARGET_ENTITY_TYPES,
  TargetEntityTypeAction,
} from 'src/action-creators/target-entity-types';


export type TargetEntityTypeState = TargetEntities;
const initialState: Array<TargetEntity> = [];

export default (
  state: TargetEntityTypeState | null | undefined = initialState,
  action: TargetEntityTypeAction,
): TargetEntityTypeState => {
  switch (action.type) {
    case RECEIVE_TARGET_ENTITY_TYPES: {
      return action.payload;
    }
  }
  // @ts-expect-error - TS2322 - Type 'TargetEntities | null' is not assignable to type 'TargetEntities'.
  return state;
};
